import { render, staticRenderFns } from "./EmailVerificationModal.vue?vue&type=template&id=5bb311a8"
import script from "./EmailVerificationModal.vue?vue&type=script&lang=js"
export * from "./EmailVerificationModal.vue?vue&type=script&lang=js"
import style0 from "./EmailVerificationModal.vue?vue&type=style&index=0&id=5bb311a8&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports